<app-dashboard-card
	title="Tasks - MTD"
	icon="pi pi-list"
>
	<div *ngIf="loading" class="dashboard-state">
		Loading task activity...
	</div>

	<div
		*ngIf="!loading && error"
		class="dashboard-state dashboard-state-error"
	>
		Unable to load task activity.
	</div>

	<div
		*ngIf="!loading && !error && tasks.length === 0"
		class="dashboard-state"
	>
		No task activity was recorded for the selected period.
	</div>

	<div
		*ngIf="!loading && !error && tasks.length > 0"
		class="tasks-table-wrapper"
	>
		<table class="tasks-table">
			<thead>
			<tr>
				<th>Task</th>
				<th>Outstanding</th>
				<th>Completed</th>
				<th>Completion %</th>
			</tr>
			</thead>

			<tbody>
			<tr *ngFor="let task of visibleTasks">
				<td class="task-name">
					{{ task.name }}
				</td>

				<td
					class="task-outstanding"
					[class.has-outstanding]="getOutstanding(task) > 0"
				>
					{{ getOutstanding(task) }}
				</td>

				<td class="task-completed">
					{{ task.completed }}
				</td>

				<td class="task-completion">
					{{ getCompletionPercentage(task) }}%
				</td>
			</tr>
			</tbody>
		</table>
	</div>

	<div
		*ngIf="!loading && !error && hasMoreTasks"
		class="dashboard-expand"
	>
		<button
			type="button"
			class="dashboard-expand-link"
			(click)="toggleExpanded()"
		>
			{{ expanded ? 'Show less' : 'Show all' }}

			<i
				class="pi"
				[ngClass]="
				expanded
					? 'pi-chevron-up'
					: 'pi-chevron-down'
			"
			></i>
		</button>
	</div>
</app-dashboard-card>
